export default "__VITE_ASSET__17108e69__"